import strings from 'strings';
import ErrorPageModel from './models/ErrorPageModel';

export const createDefaultErrorPageModel = errorCode => new ErrorPageModel({
  title: '',
  subtitle: !errorCode ? null : `${strings.error} ${errorCode}`,
  description: '',
});
